<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <!-- <i-card-top class="d-md-flex" :useBtnList="buttonUseList" @btnAdd="btnAdd()" @btnSearch="btnSearch(true)" @btnDelete="btnDelete()">
      <template v-slot:body>
        <v-layout>
          <v-row no-gutters class="pa-0 pt-2">
            <v-col cols="12" md="4">
              <v-row no-gutters>
                <v-col>
                  <i-date-time-picker
                    :firstDisplayDate="startDate"
                    placeholder="시작일자"
                    class="mx-1"
                    :dateOnly="true"
                    @getDate="setSearchDate($event, 'start')"
                    :allowMaxDate="searchMaxDate"
                  ></i-date-time-picker>
                </v-col>
                <span class="pt-1">~</span>
                <v-col>
                  <i-date-time-picker
                    :firstDisplayDate="endDate"
                    placeholder="종료일자"
                    class="mx-1"
                    :dateOnly="true"
                    @getDate="setSearchDate($event, 'end')"
                    :allowMinDate="searchMinDate"
                  ></i-date-time-picker>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-layout>
      </template>
    </i-card-top>-->
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="교육 계획" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <v-row no-gutters class="justify-end align-center">
            <v-col style="width: 200px">
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                class="mx-1"
                bg-color="white"
                :dateOnly="true"
                :menu="true"
                @getDate="setSearchDate($event, 'start')"
                :allowMaxDate="searchMaxDate"
                :functionEvents="functionEvents"
              ></i-date-time-picker>
            </v-col>
            <span class="inner_active_menu--text">~</span>
            <v-col style="width: 200px">
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                class="mx-1"
                bg-color="white"
                :dateOnly="true"
                :menu="true"
                @getDate="setSearchDate($event, 'end')"
                :allowMinDate="searchMinDate"
                :functionEvents="functionEvents"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <DxDataGrid
            id="datagridRef"
            width="100%"
            class="layout-col-height00"
            :ref="dxDataGridRef"
            :data-source="datagrid"
            :show-borders="true"
            :show-row-lines="true"
            :column-auto-width="true"
            :allow-column-resizing="true"
            :allow-column-reordering="true"
            :focused-row-enabled="true"
            key-expr="id"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
            <DxSelection select-all-mode="allPages" show-check-boxes-mode="always" mode="multiple" />
            <DxColumn data-field="clntId" data-type="string" alignment="left" caption="고객번호" :visible="false" />
            <DxColumn data-field="compId" data-type="string" alignment="left" caption="사업장번호" :visible="false" />
            <DxColumn data-field="writeDt" data-type="string" alignment="left" caption="작성일" :visible="false" />
            <DxColumn data-field="docNo" data-type="string" alignment="left" caption="문서번호" :visible="false" />
            <DxColumn
              data-field="save"
              data-type="string"
              width="120px"
              alignment="center"
              caption
              :allow-editing="false"
              cell-template="actionTemplete"
            ></DxColumn>
            <template #actionTemplete="{ data: cellInfo }">
              <div>
                <v-btn color="primary" elevation="0" dark small @click="btnDetail(cellInfo)" class="rounded px-3 grid-btn">상세보기</v-btn>
              </div>
            </template>
            <DxColumn
              css-class="devest-grid-header-require"
              data-field="educationDt"
              caption="교육일자"
              data-type="string"
              alignment="center"
              width="120px"
              :allow-editing="false"
            />
            <DxColumn
              css-class="devest-grid-header-require"
              data-field="educationDiv"
              caption="교육구분"
              data-type="string"
              alignment="center"
              width="180px"
              :allow-editing="false"
            >
              <DxLookup :data-source="educationDivList" value-expr="minorCd" display-expr="minorNm" />
            </DxColumn>
            <DxColumn
              css-class="devest-grid-header-require"
              data-field="educationNm"
              caption="교육명"
              data-type="string"
              alignment="left"
              width="340px"
              :allow-editing="false"
            />
            <DxColumn data-field="educationMemberCnt" caption="인원" data-type="string" alignment="right" width="60px" :allow-editing="false" />
            <DxColumn
              css-class="devest-grid-header-require"
              data-field="educationTime"
              caption="시간"
              data-type="string"
              alignment="center"
              width="130px"
              :allow-editing="false"
            />
            <DxColumn data-field="educationLocation" caption="장소" data-type="string" alignment="left" width="240px" :allow-editing="false" />
          </DxDataGrid>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00009'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right :useBtnList="buttonUseList" @btnAdd="btnAdd()" @btnSearch="btnSearch(true)" @btnDelete="btnDelete()"></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { getEducationPlanMaster, deleteEducationPlanMaster } from '@/api/leaderShip/educationPlan.js'
import { getCommonCode } from '@/api/common/commonApi'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import { getPreMonth, getDateToTime, getDateTimeFormat } from '@/utils/common.js'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    IDateTimePicker,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      dxDataGridRef: 'datagridRef',
      datagrid: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnDelete', //삭제
        'btnAdd' //추가
      ],
      educationDivList: [],
      startDate: getPreMonth(3),
      endDate: getPreMonth(-3),
      searchStartDate: getPreMonth(3).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(-3).replace(/[^0-9]/g, ''),
      searchMinDate: getPreMonth(3),
      searchMaxDate: getPreMonth(-3),
      initCompId: '',
      dateList: [],
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    // this.btnSearch()
  },
  activated() {
    this.dateList = []
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch(true)
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  mounted() {
    this.btnSearch(true)
    this.setCombobox()
  },
  methods: {
    functionEvents(date) {
      const [year, month, day] = date.split('-')
      if (this.dateList.includes(year + month + day)) return true
      return false
    },
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true
      })
      const toRouter = {
        name: 'EducationPlanDetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    btnSearch(isNotify) {
      this.gridInit(this.GetDataGrid(this.dxDataGridRef))

      this.openLoading('searching')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        educationTimeS: this.searchStartDate,
        educationTimeE: this.searchEndDate
      }
      getEducationPlanMaster(params, isNotify)
        .then(response => {
          if (response.success) {
            this.datagrid = _.clone(response.list)
            response.list.forEach(el => {
              this.dateList.push(el.educationDt.replaceAll('.', ''))
            })
          }
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      if (selectedRows.length === 0) {
        this.vSnackbar(this.$t('selectionData'), 'warn')
        return
      }
      // let index = selectedRows.findIndex(row => row.signExist)
      // if (index > -1) {
      //   this.vSnackbar(this.$t('서명된 계획은 수정이 불가능합니다.'), 'warn')
      //   return
      // }

      this.vToastifyPrompt(
        this.$t('계획을 삭제하시겠습니까?'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()

          this.openLoading('deleting')
          //삭제 api
          deleteEducationPlanMaster(selectedRows, true)
            .then(res => {
              if (res.success) {
              }
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
              this.btnSearch(false)
            })
        },
        null,
        true
      )
    },
    btnDetail(cellInfo) {
      const toRouter = {
        name: 'EducationPlanDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    },
    setSearchDate(e, div) {
      if (div === 'start') {
        this.searchMinDate = e
        this.searchStartDate = e.replace(/[^0-9]/g, '')
      } else if (div === 'end') {
        this.searchMaxDate = e
        this.searchEndDate = e.replace(/[^0-9]/g, '')
      }
      this.btnSearch(true)
    },
    setCombobox() {
      Promise.all([
        getCommonCode('EDU001') // 안전보건교육 구분
      ]).then(response => {
        this.educationDivList = response[0].list
      })
    }
  }
}
</script>

<style></style>
